export default {"src":"/_next/static/media/0x6694340fc020c5e6b96567843da2df01b2ce1eb6.03f06fcc.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};